import React from 'react';
import PropTypes from 'prop-types';

import {
  ReactComponent as DownArrow,
} from '@pagerduty/design-system/dist/icons/arrow-down-c.svg';
import {
  ReactComponent as UpArrow,
} from '@pagerduty/design-system/dist/icons/android-arrow-dropup.svg';
import {
  ReactComponent as RightArrow,
} from '@pagerduty/design-system/dist/icons/arrow-right-c.svg';
import styles from './style.module.css';

const ToggleStep = (props) => {
  const {
    isOpen, toggle, stepNumber, stepTitle, isDisabled, isCompleted
  } = props;

  return (
    <button
      className={styles.goalToggle}
      type="button"
      onClick={toggle}
      disabled={isDisabled}
      data-test={`step-number-${stepNumber}`}
    >
      <strong className={styles.stepNumber}>
        {!isOpen
      && <RightArrow className={styles.icon} />
      }
        {isOpen
      && <DownArrow className={styles.icon} />
      }
        {' '}
        {`Step ${stepNumber}:`}
      </strong>
      {' '}
      <span className={`${styles.stepText}`}>
        {stepTitle}
        {isCompleted && ' - Done!'}
      </span>
      {isOpen
      && (
        <span className={styles.upArrowPosition}>
          <UpArrow className={styles.upArrow} />
        </span>
      )
        }
    </button>
  );
};

ToggleStep.defaultProps = {
  isDisabled: false,
  isCompleted: false,
};

ToggleStep.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  stepNumber: PropTypes.string.isRequired,
  stepTitle: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool,
  isCompleted: PropTypes.bool,
};

export default ToggleStep;
